import React, { useState } from "react";
import { useSidebarState } from 'react-admin';

import { DashboardMenuItem, MenuItemLink } from "react-admin";

import { resourceMenu } from "../resources/";
import SubMenu from "./SubMenu";

const Menu = ({ onMenuClick, dense, logout }) => {
	const [state, setState] = useState({});
	const [open] = useSidebarState();

	const handleToggle = (menu) => {
		setState((state) => ({ ...state, [menu]: !state[menu] }));
	};

	return (
		<>
			<DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} />
			{resourceMenu.map((r) => {
				if (r.subMenu && Array.isArray(r.subMenu)) {
					const stateKey = `menu${r.to}`;

					return (
						<SubMenu
							key={r.primaryText}
							handleToggle={() => handleToggle(stateKey)}
							isOpen={!state[stateKey]}
							sidebarIsOpen={open}
							name={r.primaryText}
							icon={<r.icon />}
							dense={dense}
						>
							{r.subMenu.map((rsub) => (
								<MenuItemLink
									key={`${r.primaryText}/${rsub.primaryText}`}
									to={rsub.to}
									primaryText={rsub.primaryText}
									leftIcon={<rsub.icon />}
									onClick={onMenuClick}
									sidebarIsOpen={open}
									dense={dense}
								/>
							))}
						</SubMenu>
					);
				}
				return (
					<MenuItemLink
						key={r.primaryText}
						to={r.to}
						primaryText={r.primaryText}
						leftIcon={<r.icon />}
						onClick={onMenuClick}
						sidebarIsOpen={open}
						dense={dense}
					/>
				);
			})}
		</>
	);
};

export default Menu;
